import React from 'react';
import { Field } from 'redux-form';
import { t } from '../../modules/infra/i18n';
import RangeSelect from './rangeSelect';
import withMinuteOptions, { minuteOptionShape } from './hoc/withMinuteOptions';

const renderMinuteOptions = options => options.map(number => (
  <option value={number} key={`reminder_minutes_${number}`}>{number}</option>
));

const RemindTime = ({ minuteOptions }) => (
  <div className="u-pb- u-pt--">
    <span className="c-label c-label--light">
      {t('common:remind_time.remind_clients')}
    </span>
    <RangeSelect
      name="remindCustomers.hours"
      className="c-select layout__item u-1/5 u-mb--"
      start={0}
      end={25}
    /><span className="c-label c-label--light">{t('common:remind_time.hours_abbrev')}</span>
    <Field
      name="remindCustomers.minutes"
      component="select"
      className="c-select layout__item u-1/5 u-mb--"
    >
      <option />
      { renderMinuteOptions(minuteOptions) }
    </Field>
    <span className="c-label c-label--light">{t('common:remind_time.minutes_before')}</span>
  </div>
);

RemindTime.propTypes = {
  minuteOptions: minuteOptionShape.isRequired,
};

RemindTime.defaultProps = {};

export default withMinuteOptions(RemindTime);
